import Alert from 'bootstrap/js/src/alert';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Alert = Alert;
